var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M4.476 12.938v.004a.75.75 0 0 1-.918.533c-.647-.171-.533-.917-.533-.917l.026-.093s.039-.126.07-.217a10 10 0 0 1 1.676-2.973C6.145 7.633 8.409 6 12 6s5.856 1.633 7.201 3.274c.724.889 1.29 1.894 1.676 2.974q.048.138.09.28l.004.02.003.005v.003a.75.75 0 0 1-1.449.388l-.001-.007-.012-.037a7 7 0 0 0-.3-.78 8.6 8.6 0 0 0-1.17-1.894C16.927 8.868 15.066 7.5 12 7.5s-4.93 1.368-6.042 2.726a8.6 8.6 0 0 0-1.418 2.51l-.052.164z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M12 10.5a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m-2.25 3.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"
  })));
};
export default SvgEyeOpen;